import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Dropdown } from 'antd';
import { VERIFICATION, RESULT, EXPERIMENTS, MULTI_INTERFACE_SETUP, EXPERIMENTS_RESULT, PCB } from '@/constants/treeConstants';
import { openPage, changeTreeSelected, changeViewList, openNewPage } from '../../../store/project/action';
import { changeTabMenu, changeVerification, openTabFooter } from '../../../../tabMonitor/action';
import { startSierraVerification, changeUploadMes, updateRunSweeping } from '../../../store/simulation/action';
import {
  saveCurrentVerification,
  updateOptionsByClose,
  updateVerificationSetting,
  updateSetupAfterCloseSettings,
  updateCompSettingsStatus
} from '../../../store/sierra/action';
import SetupOptionPanel from './setupOptionPanel';
import ComponentsSetting from '@/components/ComponentsSetting'
import componentSetting from '@/services/helper/componentsHelper/compSettingHelper';
import componentDoNotStuff from '@/services/helper/componentsHelper/compDoNotStuff';
import { SIERRA } from '@/constants/pageType';
import projectDesigns from '@/services/helper/projectDesigns';
import ExtractionSetup from '../ExtractionSetup';
import CompPinMap from '../../compPinMap';
import designConstructor from '../../../../../services/helper/designConstructor';
import { PRE_LAYOUT } from '../../../../../constants/designVendor';
import { startMultiSetupSim } from '../../../store/multiInterface/action';
import { parseSpiceModelSelector } from '@/services/LibraryHelper/SpiceModelHelper';
import { getLibraryFileContent, searchPowerNetsByKeywords } from '@/services/Sierra/library';
import sierraLibrary from '@/services/Sierra/library/libraryStorage';
import { PASSIVE_SPICE, PASSIVE_TOUCHSTONE } from '../../../../../constants/libraryConstants';
import compTableHelper from '../../../../../services/Sierra/helper/compTableHelper';
import powerStore from '../../../../../services/Sierra/helper/powerNetsTableHelper';
import { TOP_BAR_RESULT } from '../../../../../services/TopBarHelper';
import NetsFilterPanel from '../../../LibraryPanel/NetsFilterPanel';
import DebugDownload from '../DebugDownload';
import getIcon from '../../../../../services/helper/iconHelper';
import MeasurementPanel from './measurement';
import Report from './Report';
import projectVerifications from '../../../../../services/Sierra/data/projectVerifications';
import Connections from '../../Connections';
import { updateExperimentInfo, exportSweepExcel, importSweepExcel, updateExportImportLogPanel } from '../../../store/sweep/action';
import { updateTreeSelectKeys } from '../../../../../services/helper/filterHelper';
import preLayoutData from '../../../../../services/Sierra/prelayout/preLayoutData';
import { SCHEMATIC } from '../../../../../services/Sierra/prelayout/prelayoutConstants';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import GenericSettings from '../../../../../components/GenericSettings';
import { topBarResize } from '@/services/helper/topBarResize';
import multiSetupDataBase from '../../../../../services/Sierra/multiInterfaceSetup/multiInterfaceDataBase';
import VictimAggressorSearch from './VictimSearch';
import './index.css';

const DEBUG = 'Debug',
  EXTRACTION_OPTIONS = 'Extraction Options',
  EXTRACTION_PORTS = 'Extraction Ports',
  SIMULATION = 'Run',
  COMPONENTS = "Components & Nets",
  OPTIONS = "Options",
  MEASUREMENT = "Measurement",
  REPORT = "Report",
  CONNECTION = "Connection",
  EXCEL_IMPORT_EXPORT = "Excel_import_export",
  EXCEL_EXPORT = "Excel_export",
  EXCEL_IMPORT = "Excel_import",
  GENERIC_SETTINGS = "generic_settings",
  VICTIM = "Aggressor-Victim Analyzer",
  ADVANCED = "Advanced";

let openVictimSearch = false;
class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      simulationloading: true,
      visible: {
        simOptions: false,
        extractionOptions: null,
        componentSetting: false,
        [MEASUREMENT]: false,
        [REPORT]: false,
        [DEBUG]: false,
        [VICTIM]: openVictimSearch,
      },
      modeling: true,
      simulation: true
    }
    this.uploadRef = createRef();
  }

  componentDidMount = () => {
    this._changeTopBarSize()
    this.screenChange();
  }

  componentDidUpdate = (prevProps) => {
    const { verificationId, currentProjectId, viewList } = this.props;
    const { visible } = this.state;
    const prevView = (prevProps.viewList || []).find(item => [MULTI_INTERFACE_SETUP, VERIFICATION, EXPERIMENTS].includes(item));
    const view = (viewList || []).find(item => [MULTI_INTERFACE_SETUP, VERIFICATION, EXPERIMENTS].includes(item));

    if (verificationId !== prevProps.verificationId || currentProjectId !== prevProps.currentProjectId || prevView !== view) {
      this.setState({
        visible: {
          ...visible,
          simOptions: false,
          componentSetting: false,
          extractionOptions: null,
          [REPORT]: false,
          [VICTIM]: false
        }
      })
    }
  }

  screenChange() {
    window.addEventListener('resize', this._changeTopBarSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._changeTopBarSize);
  }

  _changeTopBarSize = () => {
    topBarResize('sierra-top-bar', this._getTopBarWidth());
    topBarResize('sierra-pre-layout-top-bar', this._getTopBarWidth());

  }
  _getTopBarWidth = (_view) => {
    const { viewList } = this.props;
    const view = viewList.filter(item => ![PCB].includes(item));
    const showView = _view || (view.length ? view[0] : null);
    if (showView) {
      switch (showView) {
        case VERIFICATION:
          return 1430;
        case EXPERIMENTS:
          return 300;
        default: return 690;
      }
    }
    return 690;
  }

  getLibraryList = (type) => {
    if ([PASSIVE_SPICE, PASSIVE_TOUCHSTONE].includes(type)) {
      return sierraLibrary.getTree(type)
    }
    return []
  }

  openVerification = (verificationId, status) => {
    const { viewList, layout, pcbLayout, selectedKeys } = this.props;
    this.props._openPage(VERIFICATION, { verificationId });
    // cleanCompsInfo();
    let list = [...viewList, VERIFICATION];
    list = [...new Set(list)];
    list = list.filter(item => item !== RESULT);
    if (layout === 3) {
      list = [VERIFICATION]
    }
    if (status) {
      const selecteds = updateTreeSelectKeys({
        prevSelectedKeys: [...(selectedKeys || [])],
        key: VERIFICATION,
        eventKey: `${VERIFICATION}-${verificationId}`,
        selected: true,
        layout,
        pcbLayout,
        productType: SIERRA
      });
      this.props.changeTreeSelected([...selecteds]);
    }
    this.props.changeViewList(list);
    this.updateMonitorMessage(verificationId);
  }

  startVerification = () => {
    const { verificationId, simulateKeys, selectedKeys } = this.props;
    const { modeling, simulation } = this.state;

    if (simulateKeys.length === 0 && verificationId) {
      if (selectedKeys.includes(`${VERIFICATION}-${verificationId}`)) {
        //save current verification ,and do simulation
        this.props.saveCurrentVerification([verificationId], verificationId, { modeling, simulation });
        this.updateMonitorMessage(verificationId);
      }
      return;
    }

    if (simulateKeys.length === 0) {
      return;
    }
    let verificationIds = simulateKeys.map(item => item.verificationId);
    if (!verificationIds.includes(verificationId) || selectedKeys.includes(`result-${verificationId}`)) {
      this.openVerification(verificationIds[0], true);
      this.props.startSierraVerification(verificationIds, verificationIds[0], { modeling, simulation });
    } else {
      //save current verification ,and do simulation
      this.props.saveCurrentVerification(verificationIds, verificationId, { modeling, simulation });
      this.updateMonitorMessage(verificationId);
    }
  }

  startSimulation = (e) => {
    e && e.domEvent && e.domEvent.stopPropagation();
    const { viewList } = this.props;
    // Prevent clicking too fast
    if (!this.state.simulationloading) {
      return
    }
    this.setState({
      simulationloading: false
    })
    setTimeout(() => {
      this.setState({
        simulationloading: true
      })
    }, 1000);

    if (viewList.includes(VERIFICATION)) {
      this.startVerification()
    } else if (viewList.includes(EXPERIMENTS)) {
      this.startExperiment()
    } else if (viewList.includes(MULTI_INTERFACE_SETUP)) {
      const { modeling, simulation } = this.state;
      this.props._startMultiSetupSim({ modeling, simulation })
    }
  }

  startExperiment() {
    const { forSim } = this.props;
    this.props.updateRunSweeping(forSim);
    this.props.updateExperimentInfo([], 'forSim');
  }

  updateMonitorMessage = (id) => {
    const { currentProjectVerifications, currentProjectId } = this.props;
    //open monitor box
    const index = currentProjectVerifications.findIndex(item => item.id === id);
    let name = null;
    if (index > -1) {
      name = currentProjectVerifications[index].name;
    }
    this.props._changeTabMenu({ selectKeys: ['monitor'], menuType: 'simulation', verificationId: id, projectId: currentProjectId });
    this.props._changeVerification(name);
    this.props._openTabFooter();
  }

  changeVisible = (type, bool, isJudgeVerificationId) => {
    if (this.props.verificationId || !isJudgeVerificationId) {
      if (type === VICTIM) openVictimSearch = bool;
      this.setState({
        visible: {
          ...this.state.visible,
          [type]: bool,
        }
      })
    }
  }

  closeSimulationOptionsPanel = () => {
    this.props.updateOptionsByClose();
    if (this.props.verificationId) {
      this.setState({
        visible: {
          ...this.state.visible,
          simOptions: false,
        }
      })
    }
  }

  closeSettingPCB = (updateStatus, prevInfo) => {
    const { viewList } = this.props;
    const view = viewList.find(v => [VERIFICATION].includes(v));
    const _view = viewList.find(v => [VERIFICATION, MULTI_INTERFACE_SETUP].includes(v))
    if (view && updateStatus) {
      this.props.updateVerificationSetting(prevInfo)
    } else if (_view) {
      this.props._updateSetupAfterCloseSettings(_view);
    }
    this.setState({
      visible: {
        ...this.state.visible,
        componentSetting: false,
      }
    })
  }

  excelClick = ({ key }) => {
    if (key === EXCEL_EXPORT) {
      this.props._exportSweepExcel()
    }
    if (key === EXCEL_IMPORT) {
      const el = this.uploadRef.current;
      if (!el) return;
      el.click();
    }
  }

  uploadSweepExcel = (e) => {
    const file = e.target.files[0];
    this.props._importSweepExcel(file)
    this.uploadRef.current.value = ""
  }

  openExportImportLogPanel = () => {
    const { showExportImportLog } = this.props;
    if (showExportImportLog && showExportImportLog.status) {
      return;
    }
    this.props._updateExportImportLogPanel({ status: true })
  }

  getTopMenuList = () => {
    const { verificationId, simulateKeys, refNetsLoading, viewList, forSim, currentDesignId, designStatus, pcbLoading, Interfaces, selectedInterfaces, currentProjectId, sweepExportStatus, sweepImportStatus } = this.props;
    const isSweep = viewList.includes(EXPERIMENTS)
    const isInterface = viewList.includes(VERIFICATION);
    const isMultiSetup = viewList.includes(MULTI_INTERFACE_SETUP);
    const simulateEnabled = isMultiSetup
      ? (selectedInterfaces && selectedInterfaces.length ? true : false)
      : ((verificationId && !viewList.includes(EXPERIMENTS) && (!refNetsLoading || !refNetsLoading.loading)) || (simulateKeys && simulateKeys.length > 0) || (forSim && forSim.length)) ? true : false;

    const designs = designConstructor.getAvailableDesigns(currentProjectId);
    let list = [{ title: DEBUG, key: DEBUG, enabled: true, iconClassName: "iconfont icon-Debug", isSweep }];
    const report = { title: REPORT, key: REPORT, enabled: true };
    const connection = designs.length > 1 ? { title: "PCB Connections", key: CONNECTION, enabled: true, onClick: (visible) => this.changeVisible(CONNECTION, visible), iconClassName: "iconfont icon-connection-box" } : null;
    const simulationRun = { title: SIMULATION, key: SIMULATION, enabled: simulateEnabled, onClick: this.startSimulation, iconType: "play-circle" };
    const componentSetting = { title: COMPONENTS, key: COMPONENTS, enabled: !designStatus && currentDesignId ? true : false, onClick: (visible) => this.changeVisible("componentSetting", visible), iconClassName: "iconfont icon-icons8-circuit" };
    const genericSetting = { title: "Generic Settings", key: GENERIC_SETTINGS, enabled: true, onClick: (visible) => this.changeVisible(GENERIC_SETTINGS, visible), iconType: "setting" };
    const advanced = {
      title: ADVANCED,
      key: ADVANCED,
      topBarClassName: "sierra-top-bar-item-padding-2-10",
      iconClassName: "iconfont icon-advanced aurora-top-bar-advanced-icon",
      onClick: ({ key }) => this.changeVisible(key, true),
      enabled: true,
      menu: [
        (connection ? {
          key: CONNECTION,
          label: "PCB Connections"
        } : null),
        {
          key: GENERIC_SETTINGS,
          label: "Generic Settings"
        }
      ].filter(item => !!item)
    };

    //sweep
    if (isSweep) {
      const iconEndExist = (sweepExportStatus && sweepExportStatus.log && sweepExportStatus.log.length) || (sweepImportStatus && sweepImportStatus.log && sweepImportStatus.log.length)
      const sweepList = [
        simulationRun,
        {
          title: "Excel Sheet",
          key: EXCEL_IMPORT_EXPORT,
          iconClassName: "iconfont icon-file-excel-2-line",
          onClick: this.excelClick,
          enabled: true,
          endIconType: iconEndExist ? "fileText" : null,
          endIconClick: this.openExportImportLogPanel,
          menu: [{
            key: EXCEL_EXPORT,
            label: <div className="sierra-sweep-excel-label">
              <UploadOutlined />
              <span>Export</span>
            </div>
          }, {
            key: EXCEL_IMPORT,
            label: <div className="sierra-sweep-excel-label">
              <DownloadOutlined />
              <span>Import</span>
            </div>
          }]
        },
        advanced,
        report,
        {
          title: 'Result',
          key: TOP_BAR_RESULT,
          className: "sierra-top-bar-result",
          icon: {
            type: "right",
            className: "sierra-top-bar-result-icon"
          },
          onClick: this.openResult
        }].filter(item => !!item)
      return [...sweepList, ...list]
    }

    if (isInterface) {
      const extractionPortEnable = Interfaces.find(item => item.content.channel && item.content.channel.type && item.content.channel.type !== "Default" && item.content.powerNets.length > 0) ? true : false;
      let enableExtractionOptions = [];
      const postLayoutInterfaces = Interfaces.filter(item => {
        const design = designConstructor.getDesign(item.pcbId)
        if (design && design.vendor === PRE_LAYOUT) {
          const prelayoutInfo = preLayoutData.getLocalPrelayout(item.pcbId);
          if (prelayoutInfo && prelayoutInfo.content && prelayoutInfo.content.prelayout === SCHEMATIC) {
            enableExtractionOptions.push(false)
          } else {
            enableExtractionOptions.push(true)
          }
          return false
        }
        enableExtractionOptions.push(true)
        return true
      })

      const isSupportVictimSearch = Interfaces.find(item => !designConstructor.isPreLayout(item.pcbId));
      const interfaceList = [
        { ...simulationRun, showDropDown: postLayoutInterfaces.length },
        { title: OPTIONS, key: OPTIONS, enabled: verificationId ? true : false, onClick: () => this.changeVisible("simOptions", true, true), iconType: "setting" },
        enableExtractionOptions.includes(true) ? { title: EXTRACTION_OPTIONS, key: EXTRACTION_OPTIONS, enabled: !pcbLoading && Interfaces && Interfaces.length, onClick: (visible) => this.changeVisible("extractionOptions", visible ? EXTRACTION_OPTIONS : null, true), iconType: "setting" } : null,
        postLayoutInterfaces.length ? { title: EXTRACTION_PORTS, key: EXTRACTION_PORTS, enabled: !pcbLoading && extractionPortEnable, onClick: (visible) => this.changeVisible("extractionOptions", visible ? EXTRACTION_PORTS : null, true), iconType: "setting" } : null,
        componentSetting,
        { title: MEASUREMENT, key: MEASUREMENT, enabled: verificationId ? true : false, onClick: () => this.changeVisible(MEASUREMENT, true), iconType: "setting" },
        {
          ...advanced,
          menu: [
            ...advanced.menu,
            (isSupportVictimSearch ? { key: VICTIM, label: VICTIM, disabled: verificationId ? false : true } : null)
          ].filter(item => !!item)
        },
        report,
        {
          title: 'Result',
          key: TOP_BAR_RESULT,
          className: "sierra-top-bar-result",
          icon: {
            type: "right",
            className: "sierra-top-bar-result-icon"
          },
          onClick: this.openResult
        }].filter(item => !!item)

      return [...interfaceList, ...list]
    }

    if (isMultiSetup) {
      const pcbIds = multiSetupDataBase.getPcbIdsByVerificationIds(selectedInterfaces);
      const postLayouts = pcbIds.filter(pcbId => {
        const design = designConstructor.getDesign(pcbId)
        if (design && design.vendor === PRE_LAYOUT) {
          return false
        }
        return true
      })
      const multiSetupList = [
        { ...simulationRun, showDropDown: postLayouts.length },
        componentSetting,
        advanced,
        report
      ].filter(item => !!item)
      return [...multiSetupList, ...list]
    }

    const compList = [
      componentSetting,
      genericSetting,
      connection,
      report
    ].filter(item => !!item);
    return [...compList, ...list];
  }

  getPostLayoutList = (list, postLayoutDesignList) => {
    const _list = list.filter(item => {
      const vendor = designConstructor.getDesignVendor(item.id);
      if (vendor === PRE_LAYOUT) {
        return false;
      }
      return true;
    });
    if (postLayoutDesignList) {
      const { currentDesignId } = this.props;
      const findDesign = _list.find(item => currentDesignId === item.id);
      if (findDesign) {
        return findDesign.id
      }
      const _findDesign = postLayoutDesignList.find(item => _list.find(it => it.id === item.id));
      if (_findDesign) {
        return _findDesign.id
      } else {
        return postLayoutDesignList.length ? postLayoutDesignList[0].id : null
      }
    }
    return _list;
  }

  openResult = (e) => {
    e && e.stopPropagation()
    const { viewList, verificationId, experimentId } = this.props;
    const view = viewList.find(item => [EXPERIMENTS, VERIFICATION].includes(item));
    if (!view) {
      return;
    }
    let id = verificationId, pageType = RESULT;
    if (view === EXPERIMENTS) {
      id = experimentId;
      pageType = EXPERIMENTS_RESULT;
    }
    this.props._openNewPage({ pageType, id })
  }

  topItem = (item = {}) => {
    const { enabled, onClick, iconType, title, iconClassName } = item;

    const Icon = getIcon(iconType);
    return <div
      className={enabled ? 'sierra-top-bar-item' : 'sierra-top-bar-item sierra-top-bar-item-disabled'}
      onClick={enabled ? (e) => onClick(e) : null}
      key={item.title}
      title={title}
    >
      {iconType ? <Icon /> : iconClassName ? <span className={iconClassName} /> : null}
      <span className='sierra-top-bar-item-title'>{title}</span>
    </div>
  }

  updateCheckedState = (e, key) => {
    e && e.stopPropagation()
    this.setState({
      [key]: e.target.checked
    })
  }

  runItem = (item) => {
    const { enabled, onClick, iconType, title, iconClassName, } = item;
    const { modeling, simulation, /* simulationloading */ } = this.state;
    const { viewList } = this.props;
    const Icon = getIcon(iconType);
    if (viewList.includes(EXPERIMENTS) || !item.showDropDown) {
      return this.topItem(item)
    }
    return (
      <Dropdown
        key={item.title}
        disabled={!enabled}
        menu={{
          items: [{
            key: 'modeling',
            //  className: `ant-dropdown-menu-item`,
            label: <div onClick={(e) => { e && e.stopPropagation() }}>
              <Checkbox
                checked={modeling}
                onChange={(e) => this.updateCheckedState(e, "modeling")}
              >Modeling</Checkbox>
            </div>
          },
          {
            key: 'simulation',
            //  className: `ant-dropdown-menu-item`,
            label: <div onClick={(e) => { e && e.stopPropagation() }}>
              <Checkbox
                checked={simulation}
                onChange={(e) => this.updateCheckedState(e, "simulation")}
              >Simulation</Checkbox>
            </div>
          },
          {
            key: 'Run',
            className: `sierra-run-dropdown-run ${(!modeling && !simulation) || !enabled ? 'sierra-run-dropdown-run-disabled' : ''}`,
            onClick: (e) => (!modeling && !simulation) || !enabled ? null : onClick(e),
            label: 'Run'
          }]
        }}
        trigger={['click']}
        placement="bottom"
      >

        <div
          className={enabled ? 'sierra-top-bar-item' : 'sierra-top-bar-item sierra-top-bar-item-disabled'}
          // onClick={enabled ? (e) => onClick(e) : null}
          key={item.title}
          title={title}
        >
          {iconType ? <Icon /> : iconClassName ? <span className={iconClassName} /> : null}
          <span className='sierra-top-bar-item-title'>{title}</span>
        </div>
      </Dropdown>
    );
  }

  debugButtonItem = (item) => {
    const { isSweep, iconClassName } = item;
    return <div
      key={item.title}
      className='sierra-top-bar-item sierra-top-bar-right-item'
      title={item.title}
      onClick={(e) => this.openDebug(e)}
      style={isSweep ? { marginLeft: 0 } : {}}>
      <span className={iconClassName}></span>
      <span className='sierra-top-bar-item-title'>Debug</span>
    </div>
  }

  resultTopItem = (item) => {
    const { onClick, title } = item;
    return <div
      className='sierra-top-bar-item sierra-top-bar-result-item'
      key={title}
      title={title}>
      <span className='aurora-top-bar-vertical-line'></span>
      <div className='sierra-top-bar-result-title'
        title={title}
        onClick={(e) => onClick(e)}>
        <span className='sierra-top-bar-item-title'>{title}</span>
        <span className={item.icon.className}>&gt;</span>
      </div>
    </div>
  }

  dropdownItem = (item) => {
    //_updateExportImportLogPanel
    const { enabled, onClick, iconType, title, iconClassName, endIconType, endIconClick, topBarClassName } = item;
    const Icon = getIcon(iconType);
    const EndIcon = endIconType ? getIcon(endIconType) : null;
    return <Dropdown
      key={item.key}
      menu={{ items: item.menu || [], className: "", onClick }}
      onClick={(e) => e.preventDefault()}
      trigger={['hover']}
      placement={"bottom"} >
      <div
        className={(enabled ? 'sierra-top-bar-item' : 'sierra-top-bar-item sierra-top-bar-item-disabled') + (topBarClassName ? ` ${topBarClassName}` : '')}
        key={item.key}
        title={title}
      >
        {iconType ? <Icon /> : iconClassName ? <span className={iconClassName} /> : null}
        <span className='sierra-top-bar-item-title'>{title}</span>
        {endIconType ? <EndIcon
          title="Log"
          onClick={(e) => { e && e.stopPropagation(); endIconClick && endIconClick(); }}
          className="sierra-top-bar-right-icon"
        /> : null}
      </div>
    </Dropdown>
  }

  openDebug = (e) => {
    e && e.stopPropagation();
    this.setState({
      visible: { ...this.state.visible, [DEBUG]: true }
    })
  }

  closeDebug = () => {
    this.setState({
      visible: { ...this.state.visible, [DEBUG]: false }
    })
  }

  getReportItem = (itemData) => {
    const { visible } = this.state;
    const { reportProgress, reportVisible, currentProjectId } = this.props;
    const projectVerList = projectVerifications.getVerifications(currentProjectId);
    const disabledClassName = !projectVerList || !projectVerList.length ? "sierra-top-bar-item-disabled" : "";
    return reportVisible && !visible[REPORT] ? <Fragment key={itemData.key}>
      <div
        className={`sierra-top-bar-item sierra-top-bar-report-item ${disabledClassName}`}
        key={itemData.key}
        onClick={() => !disabledClassName ? this.changeVisible(REPORT, true) : null}
        style={reportVisible ? { background: '#c7e0f4' } : {}}
        title={itemData.title}
      >
        <div className='sierra-top-bar-report'>
          <span className="iconfont icon-baogao sierra-top-bar-report-icon" title={itemData.title}></span>
          <span className="sierra-top-bar-item-title">{itemData.title}</span>
        </div>
        <div className='andes-v2-top-sus-report-progress' style={{ width: `${reportProgress}%` }} />
      </div>
      <span className='andes-v2-report-progress-span'>{reportProgress}%</span>
    </Fragment>
      :
      <div className={`sierra-top-bar-item ${disabledClassName}`}
        key={itemData.key}
        onClick={!disabledClassName ? () => this.changeVisible(REPORT, true) : null}
        style={visible[itemData.key] ? { background: '#c7e0f4' } : {}}
        title={itemData.title}
      >
        <div className='sierra-top-bar-report'>
          <span className="iconfont icon-baogao sierra-top-bar-report-icon" title={itemData.title}></span>
          <span className="sierra-top-bar-item-title">{itemData.title}</span>
        </div>
      </div>
  }

  render() {
    const { width, currentProjectId, currentInterfaceDesignList,
      verificationId, Interfaces, signals,
      libraryTreeInfo, designList, updateSettingStatus, currentProjectVerifications } = this.props;
    const { visible } = this.state;
    const topMenu = this.getTopMenuList();
    const postLayoutDesignList = this.getPostLayoutList(designList);
    const componentSettingPcbId = this.getPostLayoutList(currentInterfaceDesignList, postLayoutDesignList);
    return (
      <Fragment>
        <div id='sierra-top-bar' style={{ width: width ? width : '100%' }}>
          {topMenu.map(item => {
            switch (item.key) {
              case DEBUG: return this.debugButtonItem(item);
              case REPORT: return this.getReportItem(item);
              case SIMULATION: return this.runItem(item);
              case TOP_BAR_RESULT: return this.resultTopItem(item);
              case EXCEL_IMPORT_EXPORT: return this.dropdownItem(item);
              case ADVANCED: return this.dropdownItem(item);
              default: return this.topItem(item);
            }
          })}
        </div>
        {
          visible['simOptions'] && <SetupOptionPanel
            closePanel={this.closeSimulationOptionsPanel}
          />
        }
        {
          visible['componentSetting'] ? <ComponentsSetting
            pcbId={componentSettingPcbId}
            closeModal={() => this.changeVisible('componentSetting', false)}
            projectId={currentProjectId}
            updateSetting={this.closeSettingPCB}
            settingStore={componentSetting}
            designList={postLayoutDesignList}
            doNotStuffStore={componentDoNotStuff}
            product={SIERRA}
            CompPinMap={CompPinMap}
            tableStore={compTableHelper}
            libraryTreeInfo={libraryTreeInfo}
            parseSpiceModelSelector={parseSpiceModelSelector}
            getLibraryFileContent={getLibraryFileContent}
            getLibraryList={this.getLibraryList}
            powerStore={powerStore}
            updateSettingStatus={updateSettingStatus}
            _updateCompSettingsStatus={this.props._updateCompSettingsStatus}
            ReSearchNets={NetsFilterPanel}
            searchPowerNetsByKeywords={searchPowerNetsByKeywords}
          /> : null
        }
        {
          visible['extractionOptions'] && <ExtractionSetup
            closeModal={() => this.changeVisible('extractionOptions', false, true)}
            designList={currentInterfaceDesignList}
            Interfaces={Interfaces}
            extractionType={visible['extractionOptions']}
          />
        }
        {
          visible[MEASUREMENT] ?
            <MeasurementPanel
              verificationId={verificationId}
              Interfaces={Interfaces}
              signals={signals}
              currentProjectVerifications={currentProjectVerifications}
              closePanel={() => this.changeVisible(MEASUREMENT, false)}
            />
            : null
        }
        {
          visible[REPORT] ? <Report
            closePanel={() => this.changeVisible(REPORT, false)}
          /> : null
        }
        {
          visible[DEBUG] ?
            <DebugDownload
              closeModal={this.closeDebug}
            /> : null
        }
        {
          visible[CONNECTION] ?
            <Connections
              projectId={currentProjectId}
              isTopMenu={true}
              closePanel={(visible) => this.changeVisible(CONNECTION, visible)}
            />
            : null
        }
        {
          visible[GENERIC_SETTINGS] ?
            <GenericSettings
              projectId={currentProjectId}
              product={SIERRA}
              closePanel={() => this.changeVisible(GENERIC_SETTINGS, false)}
            />
            : null
        }
        {
          visible[VICTIM] ?
            <VictimAggressorSearch
              closeModal={() => this.changeVisible(VICTIM, false, true)}
            />
            : null
        }
        <input
          type='file'
          ref={this.uploadRef}
          style={{ display: 'none' }}
          accept={".xls,.xlsx"}
          onChange={(e) => this.uploadSweepExcel(e)}
        />
      </Fragment>
    )
  }
}

const mapState = (state) => {
  const { SierraReducer: { simulationReducer: { simulateKeys },
    sierra: { expandedKeys, refNetsLoading, sierraInfo, pcbLoading, updateSettingStatus },
    project: { verificationId, selectedKeys, currentProjectId, currentProjectVerifications, layout, viewList, reportInfo, pcbLayout },
    multiInterfaceSetup: { setupData },
    library: { libraryTreeInfo },
    sweep: { experimentInfo, showExportImportLog, sweepExportStatus, sweepImportStatus } } } = state;
  let currentDesignId = '', currentInterfaceDesignList, Interfaces = [], signals = [];
  if (sierraInfo && sierraInfo.Interfaces && sierraInfo.Interfaces.length) {
    currentDesignId = sierraInfo.Interfaces[0].pcbId;
    Interfaces = sierraInfo.Interfaces;
    signals = sierraInfo.info ? sierraInfo.info.signals : []
    currentInterfaceDesignList = sierraInfo.Interfaces.map(item => { return { name: item.pcb, id: item.pcbId } });
  }

  const designList = projectDesigns.getAvailableDesigns(currentProjectId)
  if (!currentDesignId) {
    currentInterfaceDesignList = designList.map(item => { return { name: item.name, id: item.id } })
    const postLayoutInterfaces = currentInterfaceDesignList.filter(item => {
      const design = designConstructor.getDesign(item.id)
      if (design && design.vendor === PRE_LAYOUT) {
        return false
      }
      return true
    })
    currentDesignId = postLayoutInterfaces.length ? postLayoutInterfaces[0].id : ''
  }
  const { reportProgress, reportVisible } = reportInfo || {};
  return {
    simulateKeys,
    selectedKeys,
    verificationId,
    currentProjectId,
    currentProjectVerifications,
    layout,
    viewList,
    expandedKeys,
    refNetsLoading,
    forSim: experimentInfo && experimentInfo.forSim ? experimentInfo.forSim : [],
    currentDesignId,
    currentInterfaceDesignList,
    pcbLoading,
    Interfaces: Interfaces,
    signals,
    selectedInterfaces: setupData && setupData.selectedInterfaces ? setupData.selectedInterfaces : null,
    libraryTreeInfo,
    designList,
    updateSettingStatus,
    experimentId: experimentInfo && experimentInfo.id ? experimentInfo.id : null,
    reportProgress,
    reportVisible,
    pcbLayout,
    showExportImportLog,
    sweepExportStatus,
    sweepImportStatus
  }
}

const mapDispatch = (dispatch) => ({
  _openPage(view, info) {
    dispatch(openPage(view, info));
  },
  _changeTabMenu({ selectKeys, menuType, verificationId, projectId }) {
    dispatch(changeTabMenu({ selectKeys, menuType, verificationId, projectId }))
  },
  _changeVerification(name) {
    dispatch(changeVerification(name));
  },
  _openTabFooter() {
    dispatch(openTabFooter())
  },
  startSierraVerification(verificationIds, currentVerificationId, settings) {
    dispatch(startSierraVerification(verificationIds, currentVerificationId, settings));
  },
  changeTreeSelected(selectedKeys) {
    dispatch(changeTreeSelected(selectedKeys))
  },
  changeUploadMes(msg) {
    dispatch(changeUploadMes(msg));
  },
  changeViewList(viewList) {
    dispatch(changeViewList(viewList));
  },
  saveCurrentVerification(verificationIds, currentVerificationId, settings) {
    dispatch(saveCurrentVerification(verificationIds, currentVerificationId, settings))
  },
  updateOptionsByClose() {
    dispatch(updateOptionsByClose())
  },
  updateRunSweeping(forSim) {
    dispatch(updateRunSweeping(forSim))
  },
  updateExperimentInfo(info, currentType) {
    dispatch(updateExperimentInfo(info, currentType))
  },
  updateVerificationSetting(prevInfo) {
    dispatch(updateVerificationSetting(prevInfo))
  },
  _startMultiSetupSim(settings) {
    dispatch(startMultiSetupSim(settings))
  },
  _updateSetupAfterCloseSettings(view) {
    dispatch(updateSetupAfterCloseSettings(view))
  },
  _updateCompSettingsStatus(status) {
    dispatch(updateCompSettingsStatus(status))
  },
  _openNewPage({ pageType, id }) {
    dispatch(openNewPage({ pageType, id }))
  },
  _exportSweepExcel() {
    dispatch(exportSweepExcel())
  },
  _importSweepExcel(file) {
    dispatch(importSweepExcel(file))
  },
  _updateExportImportLogPanel(showExportImportLog) {
    dispatch(updateExportImportLogPanel(showExportImportLog))
  }
});

export default connect(mapState, mapDispatch)(TopBar)